module.exports = __webpack_public_path__ + "img/9788954605908.be025eb2.jpg";